<template>
  <div class="main-layout">
    <CCollapseItem>
      <template slot="title-left"> 学生基础信息 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="新增" @click="goto('')">
            <i class="iconfont icon-add"></i>
          </div>
          <!-- <div class="opt-btn" title="导入" @click="handleImport">
            <i class="iconfont icon-import"></i>
          </div> -->
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>

      <c-table
        class="div-scroll"
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        @showDetail="gotoxq"
        v-loading="pageLoading"
      >
        <!-- @edit="goto"
        @delete="pageDel" -->
      </c-table>
    </el-card>
    <!-- 添加导入弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      title="上传文件"
      :visible.sync="dialogVisible"
      @close="handleDialogClose"
      width="30%"
      custom-class="upload-dialog"
    >
      <div class="upload-container">
        <el-upload
          ref="upload"
          class="upload-box"
          drag
          :headers="importHeader"
          action="/account/base/student/importExcel"
          :http-request="customUpload"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div class="download-box">
          <el-button type="success" @click="handleDownloadTemp"
            >点击下载模板</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MExcel from "@/mixins/MExcel.js";
import Configs from "./data/basic";
import { getOrgOptions } from "@/libs/searchSelect";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/account/base/student/listPage",
  pageDelPath: "/account/base/student/",
  pageDelsPath: "",
  pageParams: {
    studentId: "",
    studentName: "",
    sex: "",
    collegeId: "",
    grade: "",
    majorId: "",
    classId: "",
  },
});
let mExcel = MExcel({
  excelTitle: "学生详情列表",
});
export default {
  mixins: [mPage, mExcel],
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      excelColumns: tableColumns,
      idList: [],
      dialogVisible: false,
      importHeader: {},
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_COLLEGE_ID"]),
  },
  created() {
    let token = localStorage.getItem("token");
    this.importHeader = { token };
    this.setCollegeId();
  },
  mounted() {},
  methods: {
    setCollegeId() {
      if (this._COLLEGE_ID) {
        this.pageParams.collegeId = this._COLLEGE_ID;
        getOrgOptions(
          this,
          { parentId: this._COLLEGE_ID, type: "department" },
          1,
          null
        );
      }
    },
    goto(data) {
      let id = data.id;
      if (data) {
        this.$router.push("/basic/studentInfo/edit/" + id);
      } else {
        this.$router.push("/basic/studentInfo/add");
      }
    },
    // 跳转到详情页
    gotoxq(data) {
      let id = data.id;
      let studentId = data.studentId;
      let idCard = data.idCard;
      this.$router.push("/basic/studentInfo/detail/" + data.studentId);
    },
    selectionChange(data) {
      this.excelData = data;
      // console.log(this.excelData);
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.searchItems[1].options = [];
      this.searchItems[2].options = [];
      this.pageParams = {
        studentId: "",
        studentName: "",
        sex: "",
        collegeId: "",
        departmentId: "",
        majorId: "",
        classId: "",
      };
      this.setCollegeId();
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    handleDialogClose() {
      this.$refs.upload.clearFiles();
      this.dialogVisible = false;
    },
    // 导入
    handleImport() {
      this.dialogVisible = true;
    },
    // 文件上传成功的回调
    uploadSuccess(msg, response, file, fileList) {
      this.$message.success(`导入数据成功！${msg}`);
      this.$refs.upload.clearFiles();
      this.dialogVisible = false;
      this.pageGet(true);
    },
    // 文件上传失败的回调
    uploadError(err, file, fileList) {
      // console.log(err);
      this.$message.error(`导入数据失败，${err}`);
    },
    // 自定义上传方法
    customUpload: function (e) {
      let that = this;
      let formData = new FormData();
      formData.append("file", e.file);
      this.$http
        .post(e.action, formData, {
          responseType: "blob",
        })
        .then((res) => {
          // console.log(res);
          if (res.type == "application/json") {
            let reader = new FileReader();
            reader.readAsText(res, "utf-8");
            reader.onload = function () {
              let resu = JSON.parse(reader.result);
              // console.log("resu:", resu);
              if (resu.code == that.SUCCESS_CODE) {
                that.uploadSuccess(resu.data);
              } else {
                that.uploadError();
              }
            };
          } else {
            that.uploadError("导入失败");
            let link = document.createElement("a"); // 创建下载链接
            link.download = "错误数据.xlsx"; //设置下载的名称
            link.style.display = "none"; // 隐藏的可下载链接
            link.href = URL.createObjectURL(res);
            // 绑定点击时间
            document.body.appendChild(link);
            link.click();
            // 然后移除
            document.body.removeChild(link);
          }
        });
      // console.log(e);
    },
    // 下载导入模板
    handleDownloadTemp() {
      window.location.href = this.$store.state.dic.STUDENT_BASE_TEMPLATE;
    },
  },
};
</script>
